///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'div[windeGridHeader]',
    standalone: false
})
export class GridHeaderDirective {
    @HostBinding('class') buttonClass = 'winde-grid-row winde-grid-header';
}
